// **************************************************
// Fullpage.js
// **************************************************
// document.addEventListener('DOMContentLoaded', () => {
//   const frontPageScrollerElem = document.querySelector('.mod-scroller .section-inner');
//   if (frontPageScrollerElem) {
//     // eslint-disable-next-line
//     const fullpageAnim = new fullpage('#fullpage', {
//       anchors: [
//         'domov',
//         'pot-do-kariere',
//         'app',
//         'top-nasveti',
//         'karierni-boost',
//         'top-jobs',
//         'studentska-dela',
//         'o-nas',
//       ],
//       licenseKey: 'K6P3H-D9O98-370K9-GWJSJ-YMRCO',
//       scrollOverflow: true,
//       scrollingSpeed: 500,
//       css3: true,
//       easing: 'easeInOutCubic',
//       touchSensitivity: 15,
//       recordHistory: false,
//       animateAnchor: true,
//     });
//   }
// });
